import { CountdownTimer } from '@components/atoms/CountdownTimer'

interface SeatReservationTimerProps {
  /**
   * Initial number of seconds remaining on the reservation.
   * Computed by the parent when the reservation is first created (pure value).
   * Null means no active reservation — hides the timer.
   */
  durationSeconds: number | null
  /** Called when the countdown reaches zero. */
  onExpire: () => void
}

/**
 * Shows the seat reservation countdown.
 * Hidden when no seats are selected (durationSeconds is null).
 * The parent is responsible for computing durationSeconds from reservedUntil
 * so that Date.now() is called in an effect, not in render.
 */
export function SeatReservationTimer({
  durationSeconds,
  onExpire,
}: SeatReservationTimerProps) {
  if (durationSeconds === null) return null

  const remainingSeconds = durationSeconds

  return (
    <div className="flex flex-col items-center gap-1">
      <span className="text-xs text-white/70">Tu selección expira en</span>
      <CountdownTimer duration={remainingSeconds} onTimeout={onExpire} />
    </div>
  )
}
